import React from 'react';
import { NeedsAssignedTable } from './NeedsAssignedTable';

export function NeedsAssigned() {
	return (
		<div className="p-4">
			<NeedsAssignedTable />
		</div>
	);
}
